module.exports = __webpack_public_path__ + "img/scooter.ee724380.png";